// Image exports - updated photos
const fitiliPremium1 = require('./fitili.png');
const fitiliPremium2 = require('./fitili 2.png');
// Main premium hero: barbell / in-use shot (0cb25289-6ee9-4d1a-b84f-2c3861fb3660.jpg)
const img1 = require('./0cb25289-6ee9-4d1a-b84f-2c3861fb3660.jpg');
const img2 = require('./6ec66057-adb2-458c-8287-111a1d7de2c5.jpg');
const img3 = require('./800a4a19-b47b-438b-930c-1545514462eb.jpg');
const img4 = require('./image.jpg');
const img5 = require('./image2.jpg');
const grayPng = require('./gray.png');

// Cheap product images
const cheapImg2 = require('./cheap ones/02322148-366b-4b76-8ab6-714e8d2986a31.avif');
const cheapImg3 = require('./cheap ones/2efd7c60-fc96-4183-b64d-c9bb5060e959.avif');
const cheapImg4 = require('./cheap ones/79937598-84a8-4d70-b9ba-09c2c1cde099.avif');
const cheapImg5 = require('./cheap ones/9e266a09-7820-442b-9e65-788f80c08398.avif');

export const heroBg = img2;
export const productMain = img1;
export const productGallery = [img1, fitiliPremium2, fitiliPremium1, img2, img3, img4, img5];

/** Galleries per color for the premium strap. Сив uses gray.png as the lead image. */
export const premiumGalleryByColor = {
    'Зелен': productGallery,
    'Сив': [grayPng, fitiliPremium2, fitiliPremium1, img2, img3, img4, img5]
};

export function getPremiumGalleryForColor(color) {
    if (color && premiumGalleryByColor[color]) {
        return premiumGalleryByColor[color];
    }
    return productGallery;
}
export const trustSection = [img1, img2, img3];
export const allImages = [img1, fitiliPremium2, fitiliPremium1, img2, img3, img4, img5];
// Use the sharper dimensions image as the first (main) cheap product photo
export const cheapProductGallery = [cheapImg2, cheapImg3, cheapImg4, cheapImg5];
